import {EventType, PublicClientApplication} from '@azure/msal-browser';
import {makeAzureAuthOptions, makeAzureScope} from 'shared';

import {
  AZURE_CLIENT_ID,
  AZURE_LOGOUT_URI,
  AZURE_POLICY,
  AZURE_TENANT,
  CONNECT_APP,
} from '@/config';

import type {
  AccountInfo,
  AuthenticationResult,
  Configuration,
  EventMessage,
} from '@azure/msal-browser';

const config: Configuration = {
  auth: {
    ...makeAzureAuthOptions(AZURE_CLIENT_ID, AZURE_TENANT, AZURE_POLICY),
    redirectUri: window.location.origin,
    postLogoutRedirectUri:
      CONNECT_APP +
      'logout-relay.html?next=' +
      encodeURIComponent(window.location.origin + AZURE_LOGOUT_URI),
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

export const msal = new PublicClientApplication(config);
msal.addEventCallback((message: EventMessage) => {
  if (message.eventType === EventType.LOGIN_SUCCESS) {
    const payload = message.payload as
      | AuthenticationResult
      | AccountInfo
      | null;
    if (!payload) throw new Error('Unexpected authentication result.');
    // MSAL v5 fires LOGIN_SUCCESS with AccountInfo; v2/v4 fires with AuthenticationResult
    const account =
      (payload as AuthenticationResult).account ?? (payload as AccountInfo);
    if (!account) throw new Error('Unexpected authentication result.');
    msal.setActiveAccount(account);
  }
});

export const mainRequest = {
  redirectUri: window.location.origin + '/auth-redirect.html',
  scopes: [
    'qii-api/qii.studio.read',
    'qii-api/qii.studio.write',
    'qii-api/qii.studio.delete',
    'qii-api/cf.download',
    'qii-api/cf.upload',
  ].map((scope) => makeAzureScope(scope, AZURE_TENANT)),
};
